选择证件地址 省/市/区

## props
options 传入数据
separator 分隔符 默认-
placeholder 输入框 默认"请选择证件地址"
selectMsgList 选择信息定制 ["选择省份", "选择城市", "选择县区"]
props 传入数据可更换key { children: 'children',label: 'label',value: 'value',disabled: 'disabled' }
##

<template>
  <div class="region-selector">
    <el-popover ref="selectpopover" trigger="click"
      :popper-options="{ boundariesElement: 'body', gpuAcceleration: false }" popper-class="region-selector-wrap"
      v-model="menuVisible" :disabled="disabled" placement="bottom-start" :visible-arrow="false" @show="showPopover">
      <div ref="select" class="region-selector_select" :class="[{'selector-bottom': !isSelectorTop }]" @click.stop>
        <div ref="header" class="header">
          <template v-for="(item, index) in currentLabels">
            <span v-show="!isInit" class="item" :key="index" @click.stop="handleSelectedClick(index)">{{item}}</span>
          </template>
          <span class="msg" v-show="selectMsg.length > 0">{{selectMsg}}</span>
        </div>
        <ul ref="list" class="list">
          <template v-for="(item, index) in menu">
            <li :key="index"
              :class="[{'gt3': item.label.length > 3 ? true: false, 'gt8': item.label.length > 8 ? true: false}]"
              @click.stop="handleMenuClick(item)">{{item.label}}</li>
          </template>
        </ul>
      </div>
      <span class="arrow"></span>
    </el-popover>
    <input ref="input" v-model="inputValue" @click.stop class="region-selector_input"
      :class="[{'is-disabled': disabled}]" :placeholder="placeholder" :readonly="true" v-popover:selectpopover />
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: []
    },
    separator: {
      type: String,
      default: "-"
    },
    disabled: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择证件地址"
    },
    selectMsgList: {
      type: Array,
      default () {
        return ["选择省份", "选择城市", "选择县区"];
      }
    },
    props: {
      type: Object,
      default () {
        return {
          children: "children",
          label: "label",
          value: "value",
          disabled: "disabled"
        };
      }
    },
    value: {
      type: Array,
      default () {
        return [];
      }
    },
  },

  data () {
    return {
      inputValue: this.value.join(this.separator) || "",
      currentValue: [],
      menu: [],
      lastMenu: [],
      menuVisible: false,
      isSelectorTop: false,
      lastClickItem: false, // 上次点击选项
    };
  },
  computed: {
    isInit () {
      // 在每次选择后，会判断是否触底
      // 如触底，则清空lastMenu；如未触底，则将menu存入lastMenu
      return this.lastMenu.length == 0 ? true : false;
    },
    selectMsg () {
      if (this.selectMsgList.length == 0 || this.selectMsgList.length < this.currentValue.length) {
        return "请选择";
      }
      if (this.isInit) {
        return this.selectMsgList[0];
      } else {
        return this.selectMsgList[this.currentValue.length];
      }
    },
    labelKey () {
      return this.props.label || "label";
    },
    valueKey () {
      return this.props.value || "value";
    },
    childrenKey () {
      return this.props.children || "children";
    },
    currentLabels () {
      let options = this.options;
      let labels = [];
      this.currentValue.forEach(value => {
        const targetOption = options && options.filter(option => option[this.valueKey] === value)[0];
        if (targetOption) {
          labels.push(targetOption[this.labelKey]);
          options = targetOption[this.childrenKey];
        }
      });
      return labels;
    }
  },
  watch: {
    value (val) {
      this.inputValue = this.value.join(this.separator) || "";
    },
    currentValue: function (newVal, oldVal) {
      this.$emit("update", newVal);
    },
  },
  methods: {
    showPopover () {
      if (this.disabled) return;
      this.lastClickItem = false;
      if (this.isInit) {
        this.menu = this.options;
      }
      this.$nextTick(_ => {
        this.setSelctPosition();
        this.$refs.list.scrollTop = 0;
      });
    },
    hidePopover () {
      // 触发校验
    },
    handleMenuClick (item) {
      if (item === this.lastClickItem) { // 阻止重复点击
        return;
      }
      // 初始化currentValue
      if (this.isInit) {
        this.currentValue = [];
      }
      // 触底，则隐藏选择区域并清空lastMenu
      if (typeof item[this.childrenKey] == "undefined") {
        this.menuVisible = false;
        this.lastMenu = [];
      } else {
        this.lastMenu = this.menu;
        this.menu = item[this.childrenKey];
        this.$nextTick(_ => {
          this.$refs["list"].scrollTop = 0;
        });
      }
      this.currentValue.push(item[this.valueKey]);
      this.$nextTick(_ => {
        // header滚动至右侧
        let header = this.$refs["header"];
        header.scrollLeft = header.scrollWidth;
      });
      this.lastClickItem = item;
    },
    handleSelectedClick (index) {
      // 点击已选择进行修改
      this.lastClickItem = false;
      if (index == 0) {
        this.menu = this.options;
      } else {
        this.menu = this.lastMenu;
      }
      this.currentValue.splice(index);
    },
    setSelctPosition () {
      // 设置选择窗体位置 箭头输入框离12px 选择窗体离24px
      let input = this.$refs["input"],
        select = this.$refs["select"],
        arrow = this.$refs["arrow"],
        inputRect = input.getBoundingClientRect();
      let clientBottom = window.innerHeight - inputRect.bottom - select.getBoundingClientRect().height; // margin 24
      // 上位置
      if (clientBottom < 0) {
        this.isSelectorTop = true;
      } else {
        // 下位置
        this.isSelectorTop = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.region-selector {
  position: relative;
  width: 45%;
  .region-selector_input {
    padding-left: 14px;//内部字与输入框距离
    border: 0.01px solid;//添加边框格式1
    border-color: rgb(220, 223, 230);//添加边框颜色
    border-radius: 5px;//添加四个圆角半径
    font-size: 14px;//添加的，输入框input文本字体的大小
    width: 90%;//修改
    height: 40px;//修改
    box-sizing: border-box;
    // .module-item-input();//vtm原有边框和格式，重购进行修改，删除
    &:focus,
    &:active {
      border-color: #4666ea;//原始颜色变化
    }
    &.is-disabled {//注释，边框颜色，格式
      color: #c0c4cc;
      background: #e5e8ec;
      border: 2px solid #a7acbd;
      // box-shadow: inset 2px 2px 2px 0px rgb(39 57 96 / 20%), inset -2px -2px 2px 0px rgb(39 57 96 / 20%);
    }
    &.is-disabled:-ms-input-placeholder {
      color: #c0c4cc;
    }

    &.is-disabled::-webkit-input-placeholder {
      color: #c0c4cc;
    }
  }
}
.region-selector-wrap {
  .arrow {
  //   display: inline-block;
  //   position: absolute;
  //   z-index: 101;
  //   left: 42px;
  //   transform: rotate(180deg);
  //   bottom: 79px;
  //   width: 28px;
  //   height: 14px;
  //   background: url("~@img/spec/arrow.png") no-repeat;
  }
  .region-selector_select {
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 101;
    bottom: 90px;
    width: 530px;
    height: 384px;
    padding: 2px 4px 10px 4px;
    background: #fff;
    box-shadow: 0px 6px 10px 0px rgba(159, 174, 162, 0.35);//注释边框颜色
    border-radius: 4px;
    box-sizing: border-box;
    &.selector-bottom {
      top: 24px;
      & + .arrow {
        top: 13px;
        transform: rotate(0deg);
      }
    }
    .header {
      flex: 0 0 58px;
      display: inline-flex;
      // align-items: flex-end;
      align-items: center;
      margin: 0 20px;
      border-bottom: 1px solid #cbd0d3;
      overflow: hidden;
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: block !important;
        width: 4px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background-color: #b2b8bb;
      }
      .item,
      .msg {
        display: inline-block;
        margin: 0 5px;
        width: 120px;
        // font-size: 24px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        line-height: 1;
        word-break: keep-all;
        color: #232323;
        // overflow: hidden;
      }
      .item:first-child {
        margin-left: 0;
      }
      .msg {
        position: relative;
        color: #1062d1;

        &::after {
          position: absolute;
          content: "";
          display: inline-block;
          left: 50%;
          bottom: -16px;
          margin-left: -18px;
          width: 36px;
          height: 4px;
          background-color: #1062d1;
          border-radius: 1px;
        }
      }
    }
    .list {
      flex-grow: 1;
      // align-items: center;
      // justify-content: center;
      margin: 10px 10px 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      overflow: hidden;
      overflow-y: auto;
      -ms-scroll-chaining: chained;
      -ms-overflow-style: none;
      -ms-content-zooming: zoom;
      -ms-scroll-rails: none;
      -ms-content-zoom-limit-min: 100%;
      -ms-content-zoom-limit-max: 500%;
      -ms-scroll-snap-type: proximity;
      -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
      -ms-overflow-style: none;
      overflow: auto;
      li {
        width: 140px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 10px;
        font-size: 14px;
        font-weight: 500;
        color: #4a4e53;
        &.gt3 {
          // font-size: 18px;//原始
          font-size: 14px;
          line-height: 20px;
        }
        &.gt8 {
          // font-size: 15px;//原始
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
<style>
.el-popover.region-selector-wrap {
  margin-top: 0 !important;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/common/regionSelector.vue